import React, {useEffect, useState} from "react";


const GrossWeightRouteOrder = (props) => {

    const {
        elemId,
        itemsRouteOrder,
        setItemsRouteOrder,
        indexItem
    } = props;

    const [grossWeightRouteOrder, setGrossWeightRouteOrder] = useState('');
    const [isGrossWeightType, setIsGrossWeightType] = useState('KGS');

    const optionGrossWeight = [
        {value: 'KGS'},
        {value: 'SQ_M'},
        {value: 'TN'},
        {value: 'PIECES'},
        {value: 'CBM'}
    ]

    useEffect(() => {
        let isMounted = true;
        const filteredNumberOrders = itemsRouteOrder.find((value) => value.id === elemId);
        const changedOrder = {...filteredNumberOrders, unitsType: isGrossWeightType}
        const updatedRouteOrder = itemsRouteOrder.map((el) => el.id === elemId ? changedOrder : el)
        isMounted && setItemsRouteOrder(updatedRouteOrder)
        return () => {
            isMounted = false;
        }
    },[isGrossWeightType])

    useEffect(() => {
        let isMounted = true;

            const filteredNumberOrders = itemsRouteOrder?.find((value) => value?.id === elemId);
            const filteredGoods = filteredNumberOrders?.goods?.find((value, index) => index === indexItem);
            const changedGoodsItem = {...filteredGoods, grossWeight: grossWeightRouteOrder};
            const updatedGoods = filteredNumberOrders?.goods?.map((el, index) => index === indexItem ? changedGoodsItem : el);
            const changedOrder = {...filteredNumberOrders, goods: updatedGoods};
            const updatedRouteOrder = itemsRouteOrder?.map((el) => el.id === elemId ? changedOrder : el);
        isMounted && setItemsRouteOrder(updatedRouteOrder)
        
        return () => {
            isMounted = false;
        }
    },[grossWeightRouteOrder])

    const onHandleGrossWeightType = (value) => {
        setIsGrossWeightType(value)
    }

    return (
        <div className="create-doc-set-loading-order-modal__table-row-container">
            <input
                className="create-doc-set-loading-order-modal__table-row-input"
                type={"number"}
                value={grossWeightRouteOrder}
                onChange={(e) => setGrossWeightRouteOrder(e.currentTarget.value)}
            />
            <select onChange={(e) => onHandleGrossWeightType(e.target.value)} className={indexItem === 0 ? "create-doc-set-loading-order-modal__select-weight" : "create-doc-set-loading-order-modal__select-weight-visibility"}>
                {optionGrossWeight.map((el, i) => {
                    return (
                        <option value={el.value} key={i}>{el.value}</option>
                    )
                })}
            </select>
        </div>
    )
}
export default GrossWeightRouteOrder;